import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { SITE } from "../lib/constants";

const SportsTraumatology = () => {
  const { t } = useLanguage();

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section
      id="sport"
      data-testid="sport-section"
      className="section-padding bg-[#0A192F] text-white relative overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 bg-grid-navy opacity-70" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -right-32 top-16 h-[28rem] w-[28rem] rounded-full bg-[#FF5A1F]/10 blur-[120px]" aria-hidden="true"></div>

      <div className="container-page relative grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <span className="chip-light mb-5">{t.sport.eyebrow}</span>
          <h2
            data-testid="sport-title"
            className="font-display font-black text-4xl sm:text-5xl leading-[1.05]"
          >
            {t.sport.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/75 leading-relaxed">
            {t.sport.lead}
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {t.sport.pillars.map((p, i) => (
              <div
                key={i}
                data-testid={`sport-pillar-${i}`}
                className="rounded-xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm hover:bg-white/10 transition"
              >
                <i className={`fa-solid ${p.icon} text-[#FF5A1F] text-xl`} aria-hidden="true"></i>
                <h3 className="mt-3 font-display font-bold text-white text-base">
                  {p.title}
                </h3>
                <p className="mt-1.5 text-xs text-white/70 leading-relaxed">
                  {p.text}
                </p>
              </div>
            ))}
          </div>

          {/* Disciplines */}
          <div className="mt-10">
            <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/50 mb-3">
              Disciplines suivies
            </p>
            <div className="flex flex-wrap gap-2">
              {t.sport.disciplines.map((d) => (
                <span
                  key={d}
                  className="rounded-full border border-white/20 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/85"
                >
                  {d}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <button
              type="button"
              data-testid="sport-cta"
              onClick={() => scrollToId("contact")}
              className="btn-primary"
            >
              <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              {t.sport.ctaLabel}
            </button>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-[#0A192F]">
              <img
                src={SITE.sportImages[2]}
                alt="Accident sportif moto — chirurgien spécialiste de la traumatologie de l'épaule à Marseille"
                className="w-full h-auto max-h-[65vh] object-contain lg:max-h-none lg:h-[560px] lg:object-cover"
                loading="lazy"
                width="1200"
                height="800"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-transparent to-transparent" />
            </div>

            {/* Secondary grid of sport impact images */}
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[SITE.sportImages[1], SITE.sportImages[3], SITE.sportImages[0]].map((src, i) => (
                <div
                  key={i}
                  className="relative aspect-[16/10] sm:aspect-[4/3] overflow-hidden rounded-lg border border-white/10 bg-[#0A192F]"
                >
                  <img
                    src={src}
                    alt="Traumatologie sport"
                    className="absolute inset-0 h-full w-full object-cover hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-[#0A192F]/10" />
                </div>
              ))}
            </div>

            {/* Floating case card */}
            <div className="absolute -left-4 md:-left-8 -bottom-10 max-w-[260px] rounded-xl bg-white p-4 text-navy shadow-2xl hidden md:block">
              <div className="flex items-center gap-2 text-[#FF5A1F]">
                <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
                <span className="text-[10px] font-bold uppercase tracking-[0.18em]">
                  Retour au jeu
                </span>
              </div>
              <p className="mt-2 font-display font-bold text-lg leading-tight">
                Rupture de coiffe arthroscopique — 4 à 6 mois
              </p>
              <p className="mt-1 text-xs text-foreground/60">
                Protocoles éprouvés sur rugby, tennis, moto, handball.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SportsTraumatology;
